import { connect } from "react-redux";
import SubHeader from "../../components/SubHeader";
import { useEffect, useState } from "react";
import { useAuth } from "../../AuthProvider";
import { pdfToMember } from "../../actions/memberAction";
import { setAuthHeaders, showErrorMessage, showSuccessMessage, buildPath, getPrefix } from "../../utils/common";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import LargePopupCertificate from "../../components/LargePopupCertificate";

import adminDefaultImg from "../../images/male-icon.png";
import defaultValues from "../../constant/defaultValues";
import { viewProfileAction } from "@/actions/viewProfileAction";
import MediumPopup from "@/components/MediumPopup";
import axiosInstance from "@/axiosHttp";
import API_URL from "@/constant/api.config";
import { isEmpty } from "lodash";
import { privateRoutePaths } from "@/routes/private.route.config";
import { useNavigate } from 'react-router-dom';

const UserSettings = (props) => {

    console.log("Props >>> ", props.companyDetail);
    const nav = useNavigate();
    const { company_plan, user, isPreKYCUser, isEndUser } = useAuth();
    const [viewCredits, setViewCredits] = useState(0);
    const [cDetail, setCDetail] = useState(null);
    const [largemodalShow, setLargeModalShow] = useState(false);
    const [upgradePlanShow, setUpgradePlanShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const { IMAGE_PATH } = defaultValues;


    const handleCertificateClick = async () => {
        if (cDetail) {
            props.showLoading();
            const data = { id: cDetail.id }
            await props.pdfToMember(cDetail.id).then((response) => {
                if (response.status === true) {

                    const pdfUrl = response.data.pdf_url;
                    // const filename = response.data.filename;

                    setPdfUrl(pdfUrl);

                    setLargeModalShow(true);
                    props.hideLoading();


                } else {
                    console.log("False", response);
                    showErrorMessage("Something went wrong!");
                }
            })
        }

    }

    const planUpgradeRequestAPI = async (type) => {
        let data = {
            member_id: user.member_id
        }

        const headers = setAuthHeaders();
        const response = await axiosInstance.post(API_URL + "/member/upgrade-plan-request", data, {
            headers
        });
        if (response) {
            if (response.data) {
                 setUpgradePlanShow(false);
                if (type !== 'supplier') {
                    showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
                } else {
                    setTimeout(() => {
                        nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: cDetail.id })}`)
                    }, 500);
                }
            }
        }
    }

    const handleupgradePlan = (type) => {
       if (type !== 'supplier') {
            setUpgradePlanShow(true);
        } else {
            planUpgradeRequestAPI(type);
        }
    }

    const createPlanRequest = async () => {
        planUpgradeRequestAPI('logistic');
    }

    useEffect(() => {
        const savedUser = localStorage.getItem("user");
        let userInfo = savedUser ? JSON.parse(savedUser) : null;
        if (userInfo) {
            setViewCredits(userInfo.view_credits);
        }
    }, []);

    useEffect(() => {
        if (!isEmpty(props.companyDetail)) {
            setCDetail(props.companyDetail.data[0]);            
        }
    }, [props.companyDetail]);

    useEffect(() => {
        const fetchDetail = async () => {
            if (user) {
                await props.viewCompany(user.member_id);
            }
        }
        fetchDetail();

    }, [user]);

    console.log("cDetail >>> ", cDetail);
    const profileImg = cDetail && cDetail.company_logo
        ? IMAGE_PATH.BASE_URL + "/company_logo/" + cDetail.company_logo
        : adminDefaultImg;

    return (<div className="u-settings shipment-details">
        <SubHeader layer1="Settings" layer2="My MemberShip" layer3="" pageName="My MemberShip" subTitle="" clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
        }} />
        <div className='bg-white my-3 py-3 card-shadow rounded'>
            <div className="container-fluid memberShip_Page">
                <div className="row">
                    <div className="col-3">
                        <div className="col-md-12">
                            <div className="img-wrape">
                                {(
                                    <img src={profileImg} alt="logo" />
                                )}
                            </div>
                            <ul className="company-detail">
                                <li className="name">
                                    {cDetail ? cDetail.company_name : "-"}
                                </li>
                                <li className="location">
                                    {cDetail && (cDetail.member_city?.name || cDetail.country?.name) ?
                                        `${cDetail.member_city?.name || ''}${cDetail.member_city?.name && cDetail.country?.name ? ', ' : ''}${cDetail.country?.name || ''}`
                                        : ''}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-9">
                        <div className="detail-wrape">
                            <h4>Other Information:</h4>
                            <ul>
                                {/* <li className="location">
                                    <span>Location:</span>
                                    {cDetail && (cDetail.member_city?.name || cDetail.country?.name) ?
                                    `${cDetail.member_city?.name || ''}${cDetail.member_city?.name && cDetail.country?.name ? ', ' : ''}${cDetail.country?.name || ''}`
                                    : ''}
                                </li>
                                <li className="name">
                                    <span>Company Name:</span> 
                                    {cDetail ? cDetail.company_name : "-"}
                                </li> */}
                                <li className="id">
                                    <span>Orex ID:</span>
                                    {cDetail ? cDetail.member_unique_number : "-"}
                                </li>
                                <li className="trade">
                                    <span>Trade Mode:</span>
                                    {cDetail ? cDetail.shipment_mode : "-"}
                                </li>
                                <li className="plan">
                                    <span>Plan Name:</span>
                                    {company_plan ? company_plan : "-"}
                                </li>
                                <li className="duration">
                                    <span>Plan Duration:</span>
                                    {cDetail && company_plan != "Trial" && cDetail.plan_from_date && cDetail.plan_to_date ? `${cDetail.plan_from_date} to ${cDetail.plan_to_date}` : `-`}
                                </li>
                                <li className="membership">
                                    <span>Membership Type:</span>
                                    {(cDetail && cDetail.badge !== null) ? cDetail.badge : "-"}
                                </li>
                                {
                                    cDetail &&
                                    <li className="certificate">
                                        <span>MemberShip Certificate:</span>
                                        {
                                            cDetail && ((cDetail.trade_mode_type === "LOG_PTR" || cDetail.trade_mode_type === "SUPPLIER") && isEndUser) && <a href="javascript:void(0)" onClick={handleCertificateClick} className="btn btn-regi">View/Download Certificate</a>
                                        }

                                        {
                                            cDetail && (((cDetail.trade_mode_type === "LOG_PTR") && isPreKYCUser)) && <a href="javascript:void(0)" onClick={() => handleupgradePlan('logistic')} className="btn btn-regi">Upgrade Plan</a>
                                        }

                                        {
                                            cDetail && (((cDetail.trade_mode_type === "SUPPLIER") && isPreKYCUser)) && <a href="javascript:void(0)" onClick={() => handleupgradePlan('supplier')} className="btn btn-regi">Upgrade Plan</a>
                                        }

                                    </li>
                                }
                                {
                                    cDetail && cDetail.is_landing_page == true &&
                                    <li className="url">
                                        <span>Landing Page URL:</span>
                                        <a className="custom-a" href={cDetail.landingURL + "/landing/" + cDetail.id} target="blank">{cDetail.landingURL}/landing/{cDetail.id}</a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <LargePopupCertificate
            // title="Certificate"
            LargeModalShow={largemodalShow}
            setLargeModalShow={setLargeModalShow}
            pdfUrl={pdfUrl}
        >
        </LargePopupCertificate>

        <MediumPopup
            title={"Unlock More with an Upgrade!"}
            mediummodalShow={upgradePlanShow}
            setMediumModalShow={setUpgradePlanShow}
            titlePosition="center-align-title"
            closeButtonLabel="Maybe Later"
            okButtonLabel="Request Upgrade"
            onSubmit={createPlanRequest}
        >
            <p>You're currently on a <b> {cDetail && cDetail.trade_mode_type === "SUPPLIER" ? 'Trial Plan' : 'Free Plan'}  </b>, which has limited access.</p>
            <p>Upgrade your plan to continue using all features without restrictions.</p>
            <p>What you will get?</p>
            <ul className="icon">
                <li>Raise unlimited inquiries</li>
                <li>Connect with verified suppliers</li>
                <li>Access complete business features</li>
                <li>Priority support</li>
            </ul>
        </MediumPopup >
    </div >)
}

const mapStateToProps = (state) => {
    return {
        update: state.update.updateProfile,
        updateCompany: state.update.updateCompany,
        companyDetail: state.companyProfile.companyDetail
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        pdfToMember: (member_id) => dispatch(pdfToMember(member_id)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        viewCompany: (member_id) => dispatch(viewProfileAction(member_id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);